<template>
  <!-- 首屏 banner 区域 -->
  <section class="banner-section">
    <div class="banner-bg"></div>
    <div class="container home_swiper">
      <div class="row">
        <div class="col-md-6">
          <div class="d-flex justify-content-start align-items-center" style="height: 700px;">
            <div class="banner-info">
              <h1 class="banner-title">
                <!-- <div><img src="@/assets/uupay/images/uu.png"></div> 
                <div class="banner-title-uu">秒過數</div> -->
                <slot name="title"></slot>
              </h1>
              <h1 class="banner-title">
                <!-- 輕鬆對接收款 -->
                <slot name="subtitle"></slot>
              </h1>
              <p class="banner-subtitle">
                <!-- 簡單 安全 迅速 / 0機價全面提升業務 -->
                <slot name="info"></slot>
              </p>
              <button class="banner-btn" @click="contactUs">聯繫我們</button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="banner-content ">
            <img src="@/assets/uupay/images/sample_mobile.png" alt="banner-img" class="img-fluid banner-img">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'UUPayBanner',
  data() {
    return {
    }
  },
  methods: {
    contactUs() {
      console.log('聯繫我們');
    },
  }
}
</script>
<style scoped>
.banner-section {
  background: linear-gradient(to bottom, #ffffff 0%, #ffe0fd 100%);
  
  width: 100%;
  height: 700px;
  position: relative;
}
.banner-info {
  max-width: 450px;
}
.banner-bg {
  height: 827px;
  background-image: url('/static/home_line.svg');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  position: absolute;
  width: 60vw;
  right: 0;
}

.banner-content {
  /*width: 870px;*/
  height: 800px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.banner-img {
  width: 620px;
  height: 680px;
  /*padding: 25px;*/
 
}


.banner-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #7b2cbf;
  display: flex;
  font-size: 70px;
  line-height: 80px;
  color: #21042e;
}
.banner-title .home1-img {
  width: 104px;
  height: 64px;
  margin-right: 10px;
}
.banner-title .home1-img img {
  width: 104px;
  height: 64px;
}
.banner-title .home2-img {
  width: 70px;
  height: 70px;
  margin-right: 10px;
}

.banner-title-uu {
  color: #9A307A;
}

.banner-subtitle {
  color: #bc68a4;
  margin: 40px 0 60px 0;
}
.banner-btn {
  width: 160px;
  height: 60px;
  border-radius: 50px;
  font-size: 18px;
  line-height: 24px;
  color: #fff;
  border: none;
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  cursor: pointer;
}
.banner-btn:focus, .banner-btn:hover {
  outline: none;
}
</style>


// WEBPACK FOOTER //
// src/components/uupayBanner.vue